<template>
  <div class="page">
    <div class="nav">
      <span
        :class="selected == '应收账龄分析' ? 'selected' : ''"
        @click="toggle('应收账龄分析')"
        >应收账龄分析</span
      >
      <span>|</span>
      <span
        :class="selected == '应收账龄表' ? 'selected' : ''"
        @click="toggle('应收账龄表')"
        >应收账龄表</span
      >
    </div>

    <div v-show="selected == '应收账龄分析'">

      <div class="filter-row">
        <div class="filter-info">
          <div class="filter-select">
            <mixed-accounts-receivable
              label=""
              v-model="con"
              @change="searchText"
            />
          </div>
          <div class="filter-input">
            <customer-field
              v-if="con == '客户'"
              label=""
              v-model="form.cu_name"
              @select="onSelectCustomer($event)"
            />
            <employee-field
              label=" "
              v-if="con == '业务员'"
              v-model="form.em_name"
              @select="onselectSeller($event)"
            />
          </div>
        </div>
      </div>
      <div class="canvas-box">
        <canvas
          id="myChart"
          class="myChart"
          v-show="result.monthitems"
        ></canvas>
        <div class="list-empty" v-if="!result.monthitems">暂无数据</div>
      </div>

      <div class="list-box" v-if="con == '全部'">
        <div class="weui-cells">
          <div
            class="weui-cell"
            v-for="(item, index) in result.monthitems"
            :key="index"
          >
            <div class="weui-cell__bd">
              <p>{{ item.text }}</p>
            </div>
            <div class="weui-cell__ft">
              <p v-format="'#,##0.00'">{{ item.amount }}</p>
            </div>
          </div>
          <div class="weui-cell weui-cell_access" v-if="result.details">
            <div class="weui-cell__bd">
              <p>合计</p>
            </div>
            <div class="weui-cell__ft">
              <p v-format="'#,##0.00'">{{ result.details[0].amount }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="list-cells" v-if="con != '全部' && result.details">
        <div
          class="list-cell"
          v-for="(item, index) in result.details"
          :key="index"
        >
          <div class="list-cell__main" @click="open(index)">
            <div class="list-cell__index">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="list-cell__content">
              <p v-if="con == '客户'">{{ item.vecuname }}</p>
              <p v-if="con == '业务员'">
                {{ item.emname }}
              </p>
              <p>{{ numberFormat(item.amount, "#,##0.##") || 0 }}</p>
            </div>
            <div class="list-cell__toggle">
              <span v-if="opened == index"
                ><i class="iconfont icon-shang"></i
              ></span>
              <span v-else><i class="iconfont icon-xia"></i></span>
            </div>
          </div>
          <div class="weui-cells" v-if="opened == index">
            <div
              class="weui-cell gray"
              v-for="(month, indexs) in textArr"
              :key="indexs"
            >
              <div class="weui-cell__bd">{{ month }}</div>
              <div class="weui-cell__ft" style="font-size: 12px" v-if="!indexs">
                {{ numberFormat(item["amount7"], "#,##0.##") || 0 }}
              </div>
              <div class="weui-cell__ft" style="font-size: 12px" v-else>
                {{ numberFormat(item["amount" + indexs], "#,##0.##") || 0 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 48px" v-show="selected == '应收账龄表'">
      <search-bar
        @search="searchReceivableAging"
        name=""
        placeholder="输入客户名称、币种进行查找"
        ref="searchBar"
      />
      <div class="weui-cells">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="(item, index) in list2"
          :key="index"
          :to="{ name: 'MoneyAgingaccountsrecReportDetail', params: { item } }"
        >
          <div class="weui-cell__bd">
            <p>{{ item.cu_name }}</p>
            <p class="list-item-muted">{{ item.cu_code }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.cu_sellername }}</p>
            <p class="list-item-muted">
              {{ item.sl_currency }}
              <span v-format="'#,##0.'">{{ item.amount }}</span>
            </p>
          </div>
        </router-link>
      </div>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ list2.length }}单</label>
        <em class="list-footer__value" v-format="'#,##0.'">{{
          getTotal("amount")
        }}</em>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import MixedAccountsReceivable from "@/components/field/MixedAccountsReceivable.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import F2 from "@antv/f2";

export default {
  components: {
    SearchBar,
    MixedAccountsReceivable,
    CustomerField,
    EmployeeField,
  },
  data() {
    return {
      result: {},
      list2: [], // 应收账龄表列表
      selected: "应收账龄分析",
      opened: -1,
      chart: null,
      condition: null,
      querytype: "全部",
      querytypeObj: {
        全部: "detail",
        客户: "cust",
        业务员: "seller",
      },
      con: "全部",
      form: {
        cu_name: null,
        em_id: null,
        em_name: null,
      },
      textArr: [
        "大于当月",
        "当月",
        "2~3个月",
        "4~6个月",
        "7~12个月",
        "1-2年",
        "2年以上",
      ],
    };
  },
  mounted() {
    this.searchRecAgeAnalysis();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    clear() {
      this.form = {
        cu_name: null,
        em_id: null,
        em_name: null,
      };
    },
    onselectSeller(selection) {
      this.form.em_name = selection.em_name;
      this.condition = "cu_sellerid =" + selection.id;
      this.searchRecAgeAnalysis();
    },
    onSelectCustomer(selection) {
      this.form.cu_name = selection.cu_name;
      this.condition = "sl_custid = " + selection.id;
      this.searchRecAgeAnalysis();
    },
    searchText() {
      this.clear();
      this.condition = null;
      this.searchRecAgeAnalysis();
    },
    searchRecAgeAnalysis() {
      let me = this,
        condition = me.condition,
        querytype = me.querytypeObj[me.con];
      let params = {
        querytype,
        con: condition ? condition : null,
      };
      
      me.$ajax({
        url: "/api/money/report/recAgeAnalysis",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.result.monthitems);
        }
      });
    },
    searchReceivableAging() {
      let me = this;

      let searchBar = me.$refs.searchBar;
      let keyword = searchBar.keyword;

      let params = {
        number: 1,
        size: 99999,
        mode: "DETAIL",
        condition: [],
        calculateFields: [
          { field: "sl_currency", operation: "max" },
          { field: "amount", operation: "sum" },
        ],
        page: 1,
        start: 0,
        limit: 99999,
      };
      if (keyword) {
        params.condition.push({
          type: "condition",
          value: `(upper(cu_name) like '%${keyword}%' or upper(sl_currency) like '%${keyword}%')`,
        });
      }
      params.condition = JSON.stringify(params.condition);

      me.$ajax({
        url: "/api/money/report/receivableAging",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list2 = res.data.list.list;
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.result.monthitems);
      }
    },
    deal2(data) {
      let me = this;
      if (!data) return;

      let arr = [{ index: -1, type: data.text, value: 0 }];
      arr[0] = {
        index: 0,
        type: data.text,
        text: me.textArr[0],
        amount: data["amount7"],
      };
      for (let i = 1; i < 7; i++) {
        arr.push({
          index: i,
          text: me.textArr[i],
          type: data.text,
          amount: data["amount" + i] || 0,
        });
      }
    
      return arr;
    },
    open(index) {
      if (index != this.opened)
        this.initChart(this.deal2(this.result.details[index]));

      this.opened = index == this.opened ? -1 : index;
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
      });

      chart.source(data);

      chart.tooltip({
        showCrosshairs: false,
        showItemMarker: false,
        onShow: function onShow(ev) {
          const items = ev.items;
          items[0].name = null;
          items[0].value = items[0].title + ": " + items[0].value;
        },
      });

      chart.interval().position("text*amount");
      chart.render();
    },
    toggle(val) {
      this.selected = val;

      if (val == "应收账龄表") {
        this.searchReceivableAging();
      }
    },
    getTotal(prop) {
      var total = 0,
        items = this.list2;
      if (items) {
        items.forEach((item) => {
          total += item[prop] || 0;
        });
      }
      return total;
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}
.list-empty {
  width: 100%;
  height: 200px;
  line-height: 200px;
  text-align: center;
  background: #fff;
  color: #8b8b8b;
  font-size: 12px;
}

.filter-row {
  width: 100%;
  padding: 1px 0px;
  background: #fff;
  /* height: 70px; */
}
.filter-info {
  /* height: 58px; */
  background-color: #fff;
  margin: 10px;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  justify-content: space-between;
  border: 1px solid var(--weui-FG-3);
}

.filter-select {
  width: 110px;
}
.filter-input {
  flex: 1;
}

.canvas-box {
  /* width: 100%;
  height: 100%; */
  overflow-x: scroll;
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.list-container {
  text-align: center;
  line-height: 40px;
  background: var(--weui-BG);
  display: flex;
  width: 100%;
}
.list-fixed {
  width: 70px;
  border-right: 1px solid var(--weui-FG-3);
}
.list-scroll {
  flex: 1;
  overflow-y: scroll;
}
.list-scroll-wrap {
  width: 640px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.list-box-col:active {
  background: #e0e0e0;
}
.list-box-col__title {
  width: 90px;
  font-weight: bold;
}
.list-fixed > .list-box-col__title {
  width: 100%;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}

.list-cells {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
  padding: 10px 0;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #8b8b8b;

  display: flex;
  justify-content: space-between;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  padding: 0 20px;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap {
    width: 100%;
  }
  .list-container {
    line-height: 25px;
  }
  .filter-row {
    display: none;
  }
}
</style>